import { render, staticRenderFns } from "./EventosActuales.vue?vue&type=template&id=3e269fc0"
import script from "./EventosActuales.vue?vue&type=script&setup=true&lang=js"
export * from "./EventosActuales.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports